export default function useCommunication() {
  const copyToClipboard = async (text: string, onCopied?: () => void) => {
    try {
      await navigator.clipboard.writeText(text);
      onCopied?.();
    } catch (error) {
      console.error('Failed to copy text:', error);
    }
  };

  const sendEmail = (email: string, subject?: string, body?: string) => {
    const mailtoUrl = new URL(`mailto:${email}`);
    if (subject) mailtoUrl.searchParams.append('subject', subject);
    if (body) mailtoUrl.searchParams.append('body', body);
    window.location.href = mailtoUrl.toString();
  };

  const sendSMS = (phoneNumber: string, message?: string) => {
    const smsUrl = new URL(`sms:${phoneNumber}`);
    if (message) smsUrl.searchParams.append('body', message);
    window.location.href = smsUrl.toString();
  };

  const callPhoneNumber = (phoneNumber: string) => {
    window.location.href = `tel:${phoneNumber}`;
  };

  return {
    copyToClipboard,
    sendEmail,
    sendSMS,
    callPhoneNumber,
  };
}